import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a1d33db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zk" }
const _hoisted_2 = { class: "zk_list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "单据类型", -1))
const _hoisted_4 = { class: "zk_list_item_n" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出库仓库", -1))
const _hoisted_6 = { class: "zk_list_item_n" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入库仓库", -1))
const _hoisted_8 = { class: "zk_list_item_n" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zk_title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zk_title_i" }),
  /*#__PURE__*/_createElementVNode("span", null, "转出物料列表")
], -1))
const _hoisted_10 = { class: "zk_wl" }
const _hoisted_11 = { class: "zk_wl_item" }
const _hoisted_12 = {
  key: 0,
  class: "green"
}
const _hoisted_13 = {
  key: 1,
  class: "yellow"
}
const _hoisted_14 = {
  key: 2,
  class: "red"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_16 = { class: "zk_wl_item_num" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = {
  key: 1,
  class: "zk_wl_w"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zk_z" }, null, -1))
const _hoisted_22 = { class: "zk_footer" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))

import { reactive, ref } from 'vue'
    import { documentType } from '@/constData'
    import { Toast } from 'vant'
    import { createZK } from '@/apis/agencyAPI'
    import { setTime } from '@/utils/utils'
    import { useRouter } from "vue-router"
    import Warehouse from '@/components/common/Warehouse.vue'
    import Materials from '@/components/common/Materials.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()

    const Material = ref(null)

    let data = reactive({
        type: '',
        outUserId: '',
        inUserId: '',
        typeName: '',
        exWarehouse: '',
        exWarehouseId: '',
        warehousingWarehouse: '',
        warehousingWarehouseName: ''
    })

    let view = reactive({
        type: false,
        Warehouse: false,
        Material: false,
        status: '',
        MaterialList: [],
        documentTypeDate: documentType,
        warehouseQualityType: '',
        customFieldName: {
            text: 'name'
        }
    })

    // 创建转库单
    const submit = () => {
        // let isOpen: boolean = true
        if (!data.type) return Toast.fail({ message: '单据类型不能为空' })
        if (!data.exWarehouse) return Toast.fail({ message: '出库仓库不能为空' })
        if (!data.warehousingWarehouse) return Toast.fail({ message: '入库仓库不能为空' })
        if (view.MaterialList.length === 0) return Toast.fail({ message: '转出物料不能为空' })
        // view.MaterialList.forEach((element: any) => {
        //     if (Number(element.total) > Number(element.num)) {
        //         // isOpen = false
        //         Toast.fail({ message: '转库的物料数量不能大于库存量！' })
        //         return
        //     }
        // })
        for (let i = 0; i < view.MaterialList.length; i++) {
            if (!view.MaterialList[i].total || view.MaterialList[i].total <= 0) {
                Toast.fail({ message: '转出数量必须大于0' })
                return
            }
            if (Number(view.MaterialList[i].total) > Number(view.MaterialList[i].num)) {
                Toast.fail({ message: '转库的物料数量不能大于库存量！' })
                return
            }
        }
        // if (isOpen) {
            let time = setTime(new Date(), '-')
            let wtransferDetailBeanList: any = []
            view.MaterialList.forEach((element: any) => {
                wtransferDetailBeanList.push({
                    batch: element.batch,
                    materialId: element.materialId,
                    procedureId: element.procedureId,
                    procedureName: element.procedureName,
                    qualityType: element.qualityType,
                    unitId: element.unitId,
                    outPlanNum: element.total,
                    proceduresId: element.procedureId,
                    inLocationId: null,
                    outLocationId: element.locationId,
                    inWarehouseId: data.exWarehouseId,
                    outWarehouseId: data.warehousingWarehouse
                })
            })
            createZK({
                type: data.type,
                outPlandate: time,
                inPlandate: time,
                origin: 0,
                outUserId: data.outUserId,
                inUserId: data.inUserId,
                inWarehouseId: data.warehousingWarehouse,
                outWarehouseId: data.exWarehouseId,
                wtransferDetailBeanList
            }).then(res => {
                if (res.code === 200) {
                    Toast.success({ message: '创建成功', forbidClick: true, duration: 2000 })
                    setTimeout(() => {
                        router.go(-1)
                    }, 2000)
                }
            })
        // }
    }

    // 删除物料
    const dele = (i: number): void => {
        if (view.MaterialList.length === 1) {
            Toast.fail({ message: '至少保留一项物料' })
            return
        }
        view.MaterialList.splice(i, 1)
    }

    // 物料回调
    const getValueWL = (val: any): void => {
        val.forEach((element: any) => {
            element.total = element.num
        })
        view.MaterialList.push(...val)
        view.Material = false
    }

    // 仓库回调
    const getValue = (val: any): void => {
        if (view.status === 'c') {
            data.exWarehouse = val.name
            data.exWarehouseId = val.id
            data.outUserId = val.managerId
        } else if (view.status === 'r') {
            data.warehousingWarehouseName = val.name
            data.warehousingWarehouse = val.id
            data.inUserId = val.managerId
            view.warehouseQualityType = val.tmodel.label
        }
        view.Warehouse = false
    }

    // 打开选择弹框
    const open = (type: string): void => {
        if (type === 'd') {
            view.type = true
        } else if (type === 'c') {
            view.status = 'c'
            view.Warehouse = true
        } else if (type === 'r') {
            view.status = 'r'
            view.Warehouse = true
        } else if (type === 'w') {
            if (data.exWarehouseId) {
                if (data.warehousingWarehouseName) {
                    let arr: Array<any> = []
                    view.MaterialList.forEach((element: any) => {
                        arr.push(element.id)
                    })
                    const { selected }: any = Material.value
                    Material.value.selected = arr
                    view.Material = true
                } else {
                    Toast.fail({ message: '请先选择入库仓库', duration: 2000 })
                }
            } else {
                Toast.fail({ message: '请先选择出库仓库', duration: 2000 })
            }
        }
    }

    // 确认单据类型
    const onConfirm = (val: any): void => {
        data.type = val.id
        data.typeName = val.name
        view.type = false
    }

    const onCancel = (): void => {
        view.type = false
    }

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "zk_list_item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (open('d')))
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              style: _normalizeStyle(_unref(data).typeName ? 'color: black;' : '')
            }, _toDisplayString(_unref(data).typeName ? _unref(data).typeName : '请选择'), 5),
            _createVNode(_component_van_icon, {
              name: "arrow",
              color: "#999999",
              size: "20"
            })
          ])
        ]),
        _createElementVNode("div", {
          class: "zk_list_item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (open('c')))
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              style: _normalizeStyle(_unref(data).exWarehouse ? 'color: black;' : '')
            }, _toDisplayString(_unref(data).exWarehouse ? _unref(data).exWarehouse : '请选择'), 5),
            _createVNode(_component_van_icon, {
              name: "arrow",
              color: "#999999",
              size: "20"
            })
          ])
        ]),
        _createElementVNode("div", {
          class: "zk_list_item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (open('r')))
        }, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              style: _normalizeStyle(_unref(data).warehousingWarehouseName ? 'color: black;' : '')
            }, _toDisplayString(_unref(data).warehousingWarehouseName ? _unref(data).warehousingWarehouseName : '请选择'), 5),
            _createVNode(_component_van_icon, {
              name: "arrow",
              color: "#999999",
              size: "20"
            })
          ])
        ])
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (_unref(view).MaterialList.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(view).MaterialList, (item, i) => {
              return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: i }, {
                right: _withCtx(() => [
                  _createVNode(_component_van_button, {
                    square: "",
                    type: "danger",
                    style: {"height":"100%"},
                    text: "删除",
                    onClick: ($event: any) => (dele(i))
                  }, null, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", null, _toDisplayString(item.materialName) + "｜" + _toDisplayString(item.materialCode), 1),
                    _createElementVNode("span", null, [
                      (item.qualityType === '0')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "合格"))
                        : _createCommentVNode("", true),
                      (item.qualityType === '1')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "不良"))
                        : _createCommentVNode("", true),
                      (item.qualityType === '2')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "报废"))
                        : _createCommentVNode("", true),
                      _hoisted_15,
                      _createElementVNode("span", null, _toDisplayString(item.procedureName ? item.procedureName : '-') + " | ", 1),
                      _createElementVNode("span", null, _toDisplayString(item.batch ? item.batch : '-'), 1)
                    ]),
                    _createElementVNode("span", null, "货位：" + _toDisplayString(item.locationName), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", null, "转出数量(" + _toDisplayString(item.unitName) + ")：", 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => ((item.total) = $event),
                        placeholder: "0"
                      }, null, 8, _hoisted_17), [
                        [_vModelText, item.total]
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
      ]),
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", {
          class: "zk_footer_wl",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (open('w')))
        }, "选择物料"),
        _hoisted_23,
        _createElementVNode("div", {
          class: "zk_footer_submit",
          onClick: submit
        }, "提交")
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _unref(view).type,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_unref(view).type) = $event)),
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择单据类型",
          columns: _unref(view).documentTypeDate,
          onConfirm: onConfirm,
          onCancel: onCancel,
          "columns-field-names": _unref(view).customFieldName
        }, null, 8, ["columns", "columns-field-names"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Warehouse, {
      show: _unref(view).Warehouse,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_unref(view).Warehouse = false)),
      onValue: getValue
    }, null, 8, ["show"]),
    _createVNode(Materials, {
      ref_key: "Material",
      ref: Material,
      show: _unref(view).Material,
      warehouseQualityType: _unref(view).warehouseQualityType,
      id: _unref(data).exWarehouseId.toString(),
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_unref(view).Material = false)),
      onValue: getValueWL
    }, null, 8, ["show", "warehouseQualityType", "id"])
  ], 64))
}
}

})